<template>
  <div>
    <div class="contents">
      <table class="table board table-sm toggle-xl">
        <thead>
          <tr>
            <th class="col-auto">{{ $t("title.common.nickname") }}</th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.hole") }}
            </th>
            <th class="col-auto">{{ $t("title.admin.shot_no") }}</th>
            <th class="col-auto">{{ $t("title.admin.club") }}</th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.distance") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.admin.remain_distance") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.score") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.admin.mulligan") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.admin.terrain") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, idx) in items">
            <tr :key="idx + 't'">
              <td class="col-auto text-start">
                <MemberInfo
                  :nickname="item.playernickname"
                  :playerno="item.playerno"
                  :no_img="true"
                />
              </td>
              <td class="col-auto d-none d-xl-table-cell">{{ item.hole }}H</td>
              <td class="col-auto">
                {{ item.shotno | shot_index }}
              </td>
              <td class="col-auto">
                {{ item.club }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.distance }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.remain }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.shotscore }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.mulliganflag }}
                <!-- {{ item.mulliganflag === '0' ? 'X' : 'O' }} -->
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.terrain }}
              </td>
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="td-arrow" @click="toggle_tr(idx)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === idx }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === idx }"
              :key="idx + 'r'"
              v-if="view_hide === idx"
            >
              <td colspan="11">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.hole") }}</div>
                    <div class="col-7">{{ item.hole }}H</div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-5">{{ $t("title.admin.shot_no") }}</div>
                    <div class="col-7">{{ item.shotno }}</div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-5">{{ $t("title.admin.club") }}</div>
                    <div class="col-7">{{ item.club }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.distance") }}
                    </div>
                    <div class="col-7">{{ item.distance }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.admin.remain_distance") }}
                    </div>
                    <div class="col-7">{{ item.remain }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.score") }}</div>
                    <div class="col-7">{{ item.shotscore }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.admin.mulligan") }}
                    </div>
                    <div class="col-7">
                      {{ item.mulliganflag }}
                      <!-- {{ item.mulliganflag === '0' ? 'X' : 'O' }} -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.admin.terrain") }}</div>
                    <div class="col-7">{{ item.terrain }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-7 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'GameDataView',
              query: {
                /*gameno: gameno,
                startdate: startdate,
                starttime: starttime,
                enddate: enddate,
                endtime: endtime,*/
              },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/gamedata";

export default {
  name: "GameDataOneShot",
  data() {
    return {
      gameno: this.$route.query.gameno,
      startdate: this.$route.query.startdate,
      starttime: this.$route.query.starttime,
      enddate: this.$route.query.enddate,
      endtime: this.$route.query.endtime,
      items: [],
      data_yn: true,
      view_hide: null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      ax.gameOneShot(this.gameno, (data) => {
        // console.log(data);
        if (data) {
          this.items = data.shotlist;
          if (data.shotlistcnt > 0) {
            this.data_yn = true;
          } else {
            this.data_yn = false;
          }
        } else {
          this.items = data.shotlist;
          this.data_yn = false;
        }
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
